module.exports = __webpack_public_path__ + "static/media/ball_s.c50a9d16.png";